export type ApiSortDirection = 'ASC' | 'DESC';

const directionMap = { asc: 'ASC', desc: 'DESC' } as const;

export const toApiSortDirection = (value: string | null | undefined): ApiSortDirection | undefined => {
  if (value === 'asc' || value === 'desc') return directionMap[value];
  if (value === 'ASC' || value === 'DESC') return value;
  return undefined;
};
